// extracted by mini-css-extract-plugin
export default {"modalHeader":"Daa-z","modalContent":"Eaa-z","formWrapper":"Faa-z","fade":"Gaa-z","fade-in":"Haa-z"};